import Vuex from "vuex";
import {getCookie, setCookie} from "@/utilities/utilities";
import moment from "moment";

export default {
    state: {
        cart: null,
        ticketTypes: null,
        slotAvailability: null,
        selector: null,
        reservationId: getCookie('reservationId')
    },
    mutations: {
        set (state, obj) {
            state[obj.key] = obj.value;
        },
        setReservationId(state, val) {
            setCookie('reservationId', val, 365);
            state.reservationId = val;
        }
    },
    actions: {
        set (context, val) {
            context.commit('set', val)
        },
        setCart(context, val) {
            context.commit('set', {key: 'cart', value: val});
        },
        setReservationId(context, val) {
            context.commit('setReservationId', val);
        }
    }
};
